export const generateSlug = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .substring(0, 60)

export const generateColor = () => {
  const colors = colorOptions
  return colors[Math.floor(Math.random() * colors.length)]
}

export const colorOptions = [
  "#E91E63", "#9C27B0", "#673AB7", "#3F51B5",
  "#2196F3", "#00BCD4", "#009688", "#4CAF50",
  "#8BC34A", "#FFC107", "#FF9800", "#FF5722",
  "#795548", "#607D8B",
]

let nextId = 100
export const generateId = () => ++nextId

export const initialCategories = [
  { id: 1, name: "Taxonomy", slug: "_root", color: "#6366f1" },
]

export const initialRelations = []
